// 폭탄 아이템 클래스 - 모든 해골 사망
class Bomb extends Item {
  constructor(scene, x = 0, z = 0) {
    super(scene, x, z);

    // 폭탄 아이템 설정
    this.modelPath = ItemConfig.BOMB.MODEL_PATH;
    this.effectDescription = "모든 해골이 파괴되었습니다!";
  }

  // 폭탄 아이템 효과 적용
  applyEffect(player) {
    if (!player) return;

    let destroyedCount = 0;

    // 게임 인스턴스에서 적들 제거
    if (window.game && window.game.enemySpawnManager) {
      window.game.enemySpawnManager.enemies.forEach((enemy) => {
        if (enemy && enemy.isAlive) {
          // 보스는 300 데미지만 입히고, 일반 적은 즉시 죽임
          if (enemy.enemyType === "WARRIOR") {
            enemy.takeDamage(300);
          } else {
            enemy.takeDamage(enemy.health);
          }
          destroyedCount++;
        }
      });
    }

    // 플레이어의 적 목록에서도 제거 (있는 경우)
    if (player.enemies && Array.isArray(player.enemies)) {
      player.enemies.forEach((enemy) => {
        if (enemy && enemy.isAlive) {
          // 보스는 300 데미지만 입히고, 일반 적은 즉시 죽임
          if (enemy.enemyType === "WARRIOR") {
            enemy.takeDamage(300);
          } else {
            enemy.takeDamage(enemy.health);
          }
          if (destroyedCount === 0) destroyedCount++; // 중복 카운트 방지
        }
      });
    }
  }

  // 폭탄만의 발광 효과 (주황빛/빨간빛 폭발)
  applyCollectionGlow(child, progress) {
    // 주황색에서 빨간색으로 변하는 폭발적인 발광 효과
    const redIntensity = Math.floor(0xaa0000 + 0x550000 * progress);
    const greenIntensity = Math.floor(0x550000 - 0x440000 * progress);
    const blueIntensity = Math.floor(0x110000 - 0x110000 * progress);
    const glowColor =
      (redIntensity << 16) | (greenIntensity << 8) | blueIntensity;
    child.material.emissive.setHex(glowColor);
  }

  // 수집 효과 연출 (폭발 효과로 이름 변경)
  playCollectionEffect() {
    this.playExplosionEffect();

    if (this.collectedPlayer) {
      this.applyEffect(this.collectedPlayer);
    }
  }

  // 폭발 효과 연출
  playExplosionEffect() {
    // 폭발 효과나 사운드 효과를 여기에 구현
    // 현재는 로그만 출력
    // Utils.log("💥 폭탄 폭발 효과!");
    // 폭탄 화면 효과 실행 (흰색 화면 FadeOut)
    if (window.game && window.game.uiManager) {
      window.game.uiManager.playBombScreenEffect();
    }
  }

  // 폭탄은 좀 더 눈에 띄게 깜빡이는 효과 추가
  update(deltaTime) {
    super.update(deltaTime);

    if (!this.isLoaded || this.isCollected || !this.model) return;

    // 위험함을 알리는 깜빡임 효과
    const elapsedTime = (performance.now() - this.startTime) / 1000;
    const blinkSpeed = 3.0; // 깜빡임 속도
    const intensity = (Math.sin(elapsedTime * blinkSpeed) + 1) * 0.5; // 0~1 사이값

    // 모델의 재질에 빨간빛 효과 추가 (있는 경우)
    this.model.traverse((child) => {
      if (child.isMesh && child.material) {
        // 원본 색상과 빨간색을 섞어서 깜빡임 효과
        if (!child.material.originalEmissive) {
          child.material.originalEmissive = child.material.emissive.clone();
        }
        child.material.emissive.setRGB(
          child.material.originalEmissive.r + intensity * 0.3,
          child.material.originalEmissive.g,
          child.material.originalEmissive.b
        );
      }
    });
  }
}

// webpack 빌드를 위해 default export 추가
export default Bomb;

// 전역 변수로도 등록 (기존 코드 호환성)
window.Bomb = Bomb;
